export type DermloopEnvironment = 'production' | 'test' | 'development' | 'ci';

export const validRegions: DermloopRegion[] = ['eu', 'us'];
export type DermloopRegion = 'us' | 'eu';
